<template>
  <!-- Why was this here? -->
  <!-- <div v-if="resourceData && Object.keys(resourceData).length !== 0"> -->
  <div v-if="resourceData || bit.type === Boolean || bit.type === 'select'">
    <!-- case object or array, assumption: only FOB Objects in arrays -->
    <span v-if="isFOBObject || isArray">
      <!-- case one-to-one -->
      <span v-if="!isArray">
        <template v-if="bit.render === 'embedded'">
          <fob-entity-details
            :resourceSchema="bit.schema"
            :resourceData="resourceData"
            :linkProvider="linkProvider"
            :isPublic="isPublic"
          ></fob-entity-details>
        </template>
        <template v-else>
          <template v-if="resourceData && !plain && constructLink(resourceData) != null">
            <fob-entity-decorator :isPublic="isPublic" :resourceData="resourceData">
              <router-link
                class="has-text-garnet"
                :to="constructLink(resourceData)"
              >
                <b-tooltip
                  :active="showTooltip(stringRep(resourceData))"
                  :label="stringRep(resourceData)"
                  type="is-basalt"
                  position="is-top"
                  size="is-small"
                  :square="true"
                >
                    {{ labelFormatter(stringRep(resourceData)) }}
                </b-tooltip>
              </router-link>
            </fob-entity-decorator>
          </template>
          <div v-else>
            <b-tooltip
              :active="showTooltip(stringRep(resourceData))"
              :label="stringRep(resourceData)"
              type="is-basalt"
              position="is-top"
              size="is-small"
              :square="true"
            >
              <fob-entity-decorator :isPublic="isPublic" :resourceData="resourceData">
                {{ labelFormatter(stringRep(resourceData)) }}
              </fob-entity-decorator>
            </b-tooltip>
          </div>
        </template>
      </span>
      <!-- case one-to-many -->
      <span v-else>
        <ul>
          <li v-for="(item, index) in sortedResourceData()"
            :key="index"
          >
            <template v-if="bit.render==='embedded'">
              <fob-entity-details
                :resourceSchema="bit.schema"
                :resourceData="item"
                :linkProvider="linkProvider"
                :isPublic="isPublic"
              ></fob-entity-details>
            </template>
            <template v-else>
              <div v-if="resourceData && !plain && constructLink(item) != null">
                <b-field v-if="useCompactComponents && hasCompactComponent(bit.schema)">
                  <router-link class="has-text-aquamarine fob-hide-in-print"
                    :to="constructLink(item)"
                  >
                    <b-icon icon="search" type="is-aquamarine" style="margin-right: 1.5rem"></b-icon>
                  </router-link>
                  <div class="fob-only-for-print-view" style="margin-right: 0.5rem">&mdash;</div>
                  <component
                    class="fob-entity-compact-component"
                    :is="compactComponentName(bit.schema)"
                    :schema="getFullSchema(bit.schema.className)"
                    :data="item"
                  ></component>
                </b-field>
                <template v-else>
                  <fob-entity-decorator :isPublic="isPublic" :resourceData="item">
                    <router-link
                      class="has-text-garnet"
                      :to="constructLink(item)"
                    >
                      <b-tooltip
                        :active="showTooltip(stringRep(item))"
                        :label="stringRep(item)"
                        type="is-aquamarine"
                        position="is-top"
                        size="is-small"
                        :square="true"
                      >
                          {{ labelFormatter(stringRep(item)) }}
                      </b-tooltip>
                    </router-link>
                  </fob-entity-decorator>
                </template>
              </div>
              <div v-else>
                <fob-entity-decorator :isPublic="isPublic" :resourceData="item">
                  {{ stringRep(item) }}
                </fob-entity-decorator>
              </div>
            </template>
          </li>
        </ul>
      </span>
    </span>
    <span v-else-if="bit.type === Date">
      {{ asDate(resourceData) }}
    </span>
    <span v-else-if="bit.type === 'timestamp'">
      {{ asTimestamp(resourceData) }}
    </span>
    <span v-else-if="bit.type === 'timestampAsDate'">
      <b-tooltip :label="asTimestamp(resourceData)">
        {{ timestampAsDate(resourceData) }}
      </b-tooltip>
    </span>
    <span v-else-if="bit.type === 'select'">
      <span v-if="bit.translatable">
        <b-tooltip
          :active="showTooltip($gettext(extractSelectLabelFromValue()))"
          :label="$gettext(extractSelectLabelFromValue())"
          type="is-aquamarine"
          position="is-top"
          size="is-small"
          :square="true"
        >
          {{ labelFormatter($gettext(extractSelectLabelFromValue())) }}
        </b-tooltip>
      </span>
      <span v-else>
        <b-tooltip
          :active="showTooltip(resourceData)"
          :label="String(resourceData)"
          type="is-aquamarine"
          position="is-top"
          size="is-small"
          :square="true"
        >
          {{ labelFormatter(resourceData) }}
        </b-tooltip>
      </span>
    </span>
    <span v-else-if="bit.type === Boolean">
      <span v-if="plain"><translate>{{ resourceData ? 'boolean.yes' : 'boolean.no' }}</translate></span>
      <b-icon v-else :icon="resourceData ? 'check-square-o' : 'square-o'"></b-icon>
    </span>
    <span v-else-if="bit.type === 'link'">
      <div class="fob-hide-in-print">
        <a :href="resourceData.href" target="_blank" rel="noopener noreferrer">
          <template v-if="resourceData.href == resourceData.text">
            {{decodeURIComponent(resourceData.text)}}
          </template>
          <template v-else>
            {{resourceData.text}}
          </template>
        </a>
        <b-icon pack="fa" icon="external-link" size="is-small"></b-icon>
      </div>
      <div class="fob-only-for-print-view">
        <div class="fob-entity-value-link-title">
          <template v-if="resourceData.href == resourceData.text">
            {{decodeURIComponent(resourceData.text)}}
          </template>
          <template v-else>
            {{resourceData.text}}
          </template>
        </div>
        <div v-if="!isUri" class="fob-entity-value-href">
          [<span>{{resourceData.href}}</span>]
        </div>
      </div>
    </span>
    <span v-else-if="bit.render === 'html'">
      <div class="html-value" v-html="resourceData"></div>
    </span>
    <!-- case default, just dump the JSON as is -->
    <span v-else>
      <b-tooltip
        :active="showTooltip(resourceData)"
        :label="String(resourceData)"
        type="is-aquamarine"
        position="is-top"
        size="is-small"
        :square="true"
      >
        {{ labelFormatter(resourceData) }}
      </b-tooltip>
    </span>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import DateTimeHelper from '@/components/mixins/DateTimeHelper'
import PublikationCompact from '@/components/compact/Publikation'
import EntityDecorator from '@/components/EntityDecorator'
import schema from '@/schema'

export default {
  name: 'fob-entity-value',
  mixins: [DateTimeHelper],
  props: {
    isPublic: Boolean,
    bit: [String, Object],
    resourceData: {
      type: [String, Boolean, Number, Object, Array, Date],
      default: null
    },
    plain: {
      type: Boolean,
      default: false
    },
    linkNested: {
      type: String,
      default: null
    },
    maxLength: {
      type: Number,
      default: null
    },
    useCompactComponents: {
      type: Boolean,
      default: false
    },
    tooltip: {
      type: Boolean,
      default: null
    },
    linkProvider: {
      type: Function,
      default: (data) => {
        const type = data._entityName.split('.').splice(-1)[0].toLowerCase()
        return {
          name: 'anzeigen_einzeln',
          params: {
            resourceType: type,
            resourceId: data._id
          }
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      loading: 'resource/isLoading',
      userRoles: 'user/roles'
    }),
    isBitList () {
      const t = Object.prototype.toString.call(this.resourceData)
      return t === '[object Array]'
    },
    isFOBObject () {
      return this.resourceData !== null &&
             typeof this.resourceData === 'object' &&
             (typeof this.resourceData._entityName !== 'undefined')
    },
    isArray () {
      return Array.isArray(this.resourceData)
    },
    isUri () {
      return this.resourceData.href === this.resourceData.text
    },
    locale () {
      return this.$language.current.substring(0, 2).toLowerCase()
    }
  },
  methods: {
    constructLink (entity) {
      return this.linkProvider(this.linkNested ? entity[this.linkNested] : entity)
    },
    stringRep (entity) {
      // TODO: Change 'stringRep' to '_stringRep' in schema definitions, remove second branch here
      if (this.bit.render === undefined) {
        return entity._stringRep
      } else if (this.bit.render === 'stringRep') {
        return entity['_stringRep']
      } else if (this.bit.render instanceof Function) {
        return this.bit.render(entity)
      } else {
        return entity[this.bit.render]
      }
    },
    labelFormatter (label) {
      if (this.bit.render !== undefined && typeof this.bit.render === 'function') {
        let rendered = this.bit.render(this.resourceData)

        if (!Array.isArray(rendered)) {
          rendered = [rendered]
        }

        if (this.bit.translatable) {
          rendered = rendered.map(s => this.$gettext(s))
        }

        return rendered.join(', ')
      }

      if (this.maxLength && label.length > this.maxLength) {
        return `${label.substring(0, this.maxLength)}...`
      } else {
        return label
      }
    },
    showTooltip (label) {
      /* show tooltips if:
         - maxLength was set AND tooltip prop is true
         - maxLength was set AND tooltip prop is not set (null)
       */
      if (this.tooltip === false) {
        return false
      } else if (this.maxLength && label.length > this.maxLength) {
        return true
      } else {
        return false // default
      }
    },
    sortedResourceData () {
      if (this.bit.sortBy) {
        let copied = [ ...this.resourceData ]
        return copied.sort((a, b) => {
          let va = a[this.bit.sortBy].toLowerCase()
          let vb = b[this.bit.sortBy].toLowerCase()
          if (va < vb) {
            return -1
          }
          if (va > vb) {
            return 1
          }
          return 0
        })
      } else {
        return this.resourceData
      }
    },
    extractSelectLabelFromValue () {
      return this.bit.values.find(x => x.value === this.resourceData).label
    },
    hasCompactComponent (schema) {
      if (schema != null && schema.className != null) {
        return `fob-${schema.className}-compact` in this.$options.components
      } else {
        return false
      }
    },
    compactComponentName (schema) {
      return `fob-${schema.className}-compact`
    },
    getFullSchema (className) {
      return schema[className]
    }
  },
  components: {
    'fob-publikation-compact': PublikationCompact,
    'fob-entity-decorator': EntityDecorator
  }
}
</script>

<style scoped lang="scss">
  li {
    margin-bottom: 1.2rem;
  }

  .nowrap {
    white-space: nowrap;
  }

  .fob-entity-value-href {
    padding-left: 5px;

    span {
      padding: 0 5px 0 5px;
    }
  }

  .html-value /deep/ {
    ol {
      list-style-type: decimal;
      margin-left: 2em;
    }
    ul {
      list-style: disc;
      margin-left: 2em;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/EntityValue.vue